import { useEffect } from 'react'
import { Link } from 'react-router-dom';
import FooterContact from '../../../component/FooterContact';
import HomeVideo2 from '../../../assets/images/banner/banner-1.mp4';

export default function Cloud() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Hero Banner */}
            <section className="pad60 box-shadow innertopbanner" style={{ position: 'relative', overflow: 'hidden' }}>
                <div className="overlay-top-left"></div>
                <div className="container">
                    <div className="row align-items-center height100">
                        <div className="col-lg-7 col-md-12">
                            <div className="banner-caption">
                                <div itemScope itemType="http://schema.org/BreadcrumbList" className="breadcrumbs">
                                    <ul>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <Link to="/"><span itemProp="name">Home</span></Link>
                                            <meta itemProp="position" content="1" />
                                        </li>
                                        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
                                            <i className="icofont-thin-right"></i>
                                            <span itemProp="name">Cloud Services</span>
                                            <meta itemProp="position" content="2" />
                                        </li>
                                    </ul>
                                </div>
                                <div className="prod-section-label">Cloud Services</div>
                                <h1 className="prod-hero-title">Transform Your Business with <span>CLOUD MIND's Cloud Services</span></h1>
                                <p>Make the right technology investments at the right time and on the right platforms to drive innovation, increase customer loyalty and grow your business.</p>
                                <div className="button_services mt-4">
                                    <Link to="/contact"><button className="prod-cta-btn">Contact Us &nbsp;<i className="fa fa-arrow-right"></i></button></Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-5 col-md-12">
                            <div className="banner-mobiles text-center">
                                <img src={require('../../../assets/images/services/products/data-bg-transparant.webp')} alt="Cloud Services" />
                            </div>
                        </div>
                    </div>
                </div>
                <video autoPlay loop muted style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                    <source src={HomeVideo2} type="video/mp4" />
                </video>
            </section>

            {/* Stats */}
            <section style={{ background: '#0a0a0a', padding: '0 0 20px' }}>
                <div className="container">
                    <div className="prod-stats-row">
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">3x</div>
                            <div className="prod-stat-label">ROI on Cloud Investment</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">1500+</div>
                            <div className="prod-stat-label">Apps Migrated to Cloud</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">99.9%</div>
                            <div className="prod-stat-label">Uptime SLA</div>
                        </div>
                        <div className="prod-stat-item">
                            <div className="prod-stat-number">100s</div>
                            <div className="prod-stat-label">Mainframe Systems Modernized</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Cloud Security */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/cloud-migration..jpg')} alt="Cloud Security" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Cloud Security</div>
                                <h2>Get the Business Outcomes You Expect</h2>
                                <p>When cloud is done right, it can provide up to three times the return on investment and faster business results, with less cost, risk and disruption. CLOUD MIND helps you make the right decisions about what applications to migrate to cloud and when.</p>
                                <p>We understand the role cloud plays in mission-critical IT because we manage hybrid IT environments for many of the world's largest companies. We've modernized hundreds of mainframe systems and transformed 1500+ applications to cloud.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '8px', display: 'inline-flex' }}>
                                    Talk to Experts <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Cloud Advisory */}
            <section className="prod-highlight-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Advisory</div>
                        <h2 className="prod-section-title">Cloud <span>Advisory Services</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Leverage precision-guided modernization — making the right decisions at the right time for accelerated cloud transformation.</p>
                    </div>
                    <div className="prod-features-grid" style={{ paddingTop: 0 }}>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-rocket"></i></div>
                            <h4>Unlock Business Agility</h4>
                            <p>Business demands for applications that are industry relevant, accessible and future-ready call for faster and more agile cloud-based platforms.</p>
                            <div className="prod-feature-number">01</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-cloud"></i></div>
                            <h4>Hybrid Cloud</h4>
                            <p>Competing in today's business environment requires IT modernization — moving workloads to cloud while maintaining the security and stability of existing environments.</p>
                            <div className="prod-feature-number">02</div>
                        </div>
                        <div className="prod-feature-card">
                            <div className="prod-feature-icon"><i className="fa fa-server"></i></div>
                            <h4>Multi Cloud</h4>
                            <p>CLOUD MIND enables enterprises to run traditional workloads and modernize applications for private and public cloud, removing the complexity of IaaS, PaaS, and container management.</p>
                            <div className="prod-feature-number">03</div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Migration Services */}
            <section className="prod-dark-section">
                <div className="container">
                    <div className="text-center mb-5">
                        <div className="prod-section-label" style={{ margin: '0 auto 16px' }}>Migration</div>
                        <h2 className="prod-section-title">Migration <span>Services</span></h2>
                        <p className="prod-section-sub" style={{ margin: '0 auto' }}>Expert services to rehost, replatform or rearchitect servers, applications, and databases to public, private or hybrid clouds.</p>
                    </div>
                    <div className="row align-items-center">
                        <div className="col-lg-6">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/multi-cloud-security.jpg')} alt="Managed Multicloud" />
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="prod-info-content">
                                <div className="prod-section-label">Managed Services</div>
                                <h2>Managed Multicloud Services</h2>
                                <p>Reap the advantages of a flexible hybrid or multicloud strategy. Our hybrid platforms provide managed services for compute, storage and network infrastructure as well as full-stack application support.</p>
                                <ul className="prod-benefits-list mt-3">
                                    <li><span className="ben-dot">✓</span>On-time and within-budget migration guarantee</li>
                                    <li><span className="ben-dot">✓</span>Proven, scalable methodology for all cloud types</li>
                                    <li><span className="ben-dot">✓</span>Full-stack application and infrastructure support</li>
                                    <li><span className="ben-dot">✓</span>Continuous security and compliance monitoring</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Virtual Private Cloud */}
            <section className="prod-info-section" style={{ background: '#0a0a0a' }}>
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-lg-6 order-lg-2">
                            <div className="prod-info-image">
                                <img src={require('../../../assets/images/services/products/virtual-cloud.png')} alt="Virtual Private Cloud" style={{ height: 320, objectFit: 'contain', background: 'rgba(255,255,255,0.04)', borderRadius: 16 }} />
                            </div>
                        </div>
                        <div className="col-lg-6 order-lg-1">
                            <div className="prod-info-content" style={{ paddingLeft: 0, paddingRight: 40 }}>
                                <div className="prod-section-label">Private Cloud</div>
                                <h2>Virtual Private Cloud Services</h2>
                                <p>Safeguard your IT environment with a highly secure multitenant cloud platform. Our services tune virtual and physical server configurations to match your application workloads, ensuring optimal performance and security.</p>
                                <Link to="/contact" className="prod-cta-btn" style={{ marginTop: '8px', display: 'inline-flex' }}>
                                    Get Started <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* CTA */}
            <section style={{ background: '#0a0a0a', padding: '0 0 80px' }}>
                <div className="container">
                    <div className="prod-cta-banner">
                        <div>
                            <h3>Ready to Start Your Cloud Journey?</h3>
                            <p>Let us help you define, execute and manage your cloud strategy with confidence.</p>
                        </div>
                        <Link to="/contact" className="prod-cta-btn">
                            Start Now <i className="fa fa-arrow-right" style={{ marginLeft: 8 }}></i>
                        </Link>
                    </div>
                </div>
            </section>

            <FooterContact />
        </>
    )
}
